import { styled as r } from "styled-components";
import { defaultCardSpacing as p } from "../style.js";
const a = r.div`
  ${p}
`;
export {
  a as InputWrapper
};
